import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Assigns and unassigns Map Sets to a Vehicle Group
 * @param vehicleGroupId The ID of the Vehicle Group who the Map Sets are being assigned
 * @param add The IDs of the Map Sets being assigned
 * @param remove The IDs of the Map Sets being unassigned
 * @returns Data object indicating success
 */
export function putVehicleGroupsMapSets(
  this: unknown,
  vehicleGroupId: number,
  add: number[],
  remove: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehicleGroupsIdMapsetsUrl(String(vehicleGroupId)),
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            add,
            remove,
          }),
        }
      )
    )
  ).pipe(selectData(z.object({ data: z.boolean() })));
}
